import React from 'react';
import classnames from 'classnames';

import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowRight from '@mui/icons-material/ArrowRight';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

import { Button } from 'uikit/buttons';

import styles from '../styles/nestedList.module.scss';

const getIcon = ({ isExpanded, toggleIconSize, toggleType }) => {
  if (toggleType === 'triangle') {
    return isExpanded ? <ArrowDropDown sx={{ height: toggleIconSize, width: toggleIconSize }} /> : <ArrowRight sx={{ height: toggleIconSize, width: toggleIconSize }} />;
  }

  return isExpanded ? <KeyboardArrowDown sx={{ height: toggleIconSize, width: toggleIconSize }} /> : <KeyboardArrowRight sx={{ height: toggleIconSize, width: toggleIconSize }} />;
}

const NestedList = ({
  bodyAriaLabel,
  bodyClassName,
  children,
  className,
  expandedClassName,
  hasToggle,
  header,
  headerClassName,
  headerPrepend,
  id,
  isExpanded,
  onToggleClick,
  toggleAriaLabel,
  toggleButtonSize,
  toggleClassName,
  toggleIconSize,
  toggleType,
}) => (
  <div
    className={classnames(styles.element, {
      [classnames(styles.isExpanded, expandedClassName)]: isExpanded,
    }, className)}
  >
    <div className={classnames(styles.headerContainer, headerClassName)}>
      <div className={styles.headerPrepend}>
        {headerPrepend}
        {hasToggle && (
          <Button
            ariaLabel={toggleAriaLabel}
            aria-expanded={isExpanded}
            className={classnames(styles.toggle, toggleClassName)}
            icon={getIcon({isExpanded, toggleIconSize, toggleType})}
            id={id}
            onClick={() => onToggleClick(id)}
            size={toggleButtonSize}
            variant="ghost"
          />
        )}
      </div>
      {header}
    </div>
    <div
      aria-label={bodyAriaLabel}
      className={classnames(styles.body, bodyClassName)}
      role="region"
    >
      {children}
    </div>
  </div>
);

export default React.memo(NestedList);
